import { useContext, useMemo } from 'react';

import { LoggerReactContext } from './context';
import { LoggerNodeInfo, LoggerNodeInfoOverride } from './types';

import { normalizeNode } from './normalizeNode';

/** @deprecated Используйте createUseLogger для создания useLogger в рамках вашего сервиса */
export function useLogger(nodeInfo: LoggerNodeInfo | string, overrideNodeInfo?: LoggerNodeInfoOverride | string) {
    const { useLogger: useLoggerImplementation } = useContext(LoggerReactContext);

    const parsedNodeInfo = useMemo(() => normalizeNode(nodeInfo), [nodeInfo]);
    const parsedOverrideNodeInfo = useMemo(
        () => (overrideNodeInfo ? normalizeNode(overrideNodeInfo) : undefined),
        [overrideNodeInfo]
    );

    return useLoggerImplementation(parsedNodeInfo, parsedOverrideNodeInfo);
}
